import React from 'react';
import { Youtube, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black pt-20 pb-8 border-t border-eofa-dark" data-id="element-37">
      <div className="container mx-auto px-6" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left" data-id="element-39">
          {/* Column 1: Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-40">
            <div className="mb-4" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/6DgCkWRHtBFs2JEwqHrY5r/e-of-a-logo-v2.png" alt="Entrepreneurs of America by LetLois" className="h-16 w-auto" data-id="element-42" />
            </div>
            <p className="text-eofa-body text-sm max-w-[250px]" data-id="element-43">
              Real conversations with everyday business owners.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col items-center md:items-start space-y-3" data-id="element-44">
            <h4 className="text-eofa-white font-bold mb-2" data-id="element-45">Quick Links</h4>
            <a href="#" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-46">
              Home
            </a>
            <a href="#" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-47">
              Episodes
            </a>
            <a href="#" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-48">
              About
            </a>
            <a href="#" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-49">
              Be a Guest
            </a>
            <a href="#" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-50">
              Contact
            </a>
          </div>

          {/* Column 3: Connect */}
          <div className="flex flex-col items-center md:items-start space-y-4" data-id="element-51">
            <h4 className="text-eofa-white font-bold mb-1" data-id="element-52">Connect</h4>
            <a href="mailto:info@letlois.com" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-53">
              info@letlois.com
            </a>
            <a href="https://letlois.com" target="_blank" rel="noopener noreferrer" className="text-eofa-white text-sm hover:text-eofa-yellow transition-colors" data-id="element-54">
              letlois.com
            </a>

            <div className="flex items-center gap-4 pt-2" data-id="element-55">
              <a href="https://www.youtube.com/@EofApod" target="_blank" rel="noopener noreferrer" className="text-eofa-white hover:text-eofa-yellow transition-colors p-2 -ml-2" aria-label="YouTube" data-id="element-56">
                <Youtube size={24} data-id="element-57" />
              </a>
              <a href="https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8" target="_blank" rel="noopener noreferrer" className="text-eofa-white hover:text-eofa-yellow transition-colors p-2" aria-label="Spotify" data-id="element-58">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-59">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.48.659.24 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.84.24 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.6.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.54-1.02.72-1.56.3z" data-id="element-60" />
                </svg>
              </a>
              <a href="#" className="text-eofa-white hover:text-eofa-yellow transition-colors p-2" aria-label="Instagram" data-id="element-61">
                <Instagram size={24} data-id="element-62" />
              </a>
              <a href="#" className="text-eofa-white hover:text-eofa-yellow transition-colors p-2" aria-label="TikTok" data-id="element-63">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-64">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.95v7.4c-.01 1.96-.81 3.82-2.15 5.22-1.34 1.4-3.24 2.22-5.2 2.26-1.96.04-3.88-.7-5.28-2.05-1.4-1.35-2.24-3.21-2.31-5.17-.07-1.96.65-3.86 1.96-5.3 1.31-1.44 3.16-2.33 5.12-2.46h.14V12.1c-1.15.06-2.27.5-3.14 1.25-.87.75-1.44 1.79-1.6 2.93-.16 1.14.1 2.31.74 3.27.64.96 1.62 1.63 2.75 1.88 1.13.25 2.32.14 3.38-.32 1.06-.46 1.92-1.28 2.4-2.31.48-1.03.62-2.2.4-3.32V.02h-1.1z" data-id="element-65" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-eofa-yellow flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-66">
          <span className="text-eofa-muted text-xs" data-id="element-67">
            © 2026 LetLois. All rights reserved.
          </span>
          <a href="https://letlois.com" target="_blank" rel="noopener noreferrer" className="text-eofa-muted text-xs hover:text-eofa-yellow transition-colors" data-id="element-68">
            Site by LetLois
          </a>
        </div>
      </div>
    </footer>;
}